<template>
    <div>
        <ul class="select-payment-tabs">
            <li class="select-payment-tab">
                <a
                    class="select-payment-tab-link"
                    @click.prevent="!qrCodePath.length ? setActive('credit_card') : ''"
                    :class="{ active: isActive('credit_card'), disabled: !disabled || qrCodePath.length }"
                    href="#credito"
                    ><span class="material-icons"> credit_card </span>Crédito</a
                >
            </li>
            <li class="select-payment-tab">
                <a
                    class="select-payment-tab-link"
                    @click.prevent="!qrCodePath.length ? setActive('bank_slip') : ''"
                    :class="{ active: isActive('bank_slip'), disabled: !disabled || qrCodePath.length }"
                    href="#boleto"
                    ><span class="material-icons"> receipt </span>Boleto</a
                >
            </li>
            <li class="select-payment-tab">
                <a
                    class="select-payment-tab-link"
                    @click.prevent="!qrCodePath.length ? setActive('pix') : ''"
                    :class="{ active: isActive('pix'), disabled: !disabled || qrCodePath.length }"
                    href="#pix"
                    ><span class="material-icons"> pix </span>Pix</a
                >
            </li>
        </ul>
        <div class="select-payment-content" v-if="disabled">
            <div
                class="select-payment-content-pane"
                :class="{ 'active show': isActive('credit_card') }"
                id="credit_card"
            >
                <div>
                    <card-list
                        v-if="getCreditCardList"
                        :creditCards="creditCards"
                        @showForm="openForm"
                        :addNewCard="!showForm"
                        @setSelectedCard="setSelectedCard"
                        @deleteSelectedCard="deleteSelectedCard"
                        :changeSelectedCard="changeSelectedCard"
                    ></card-list>
                    <div v-else>
                        <p class="creditcard-message">
                            Nenhum cartão cadastrado. Preencha os campos abaixo para prosseguir com a compra.
                        </p>
                    </div>
                    <card-form
                        v-if="showForm"
                        @cardForm="registerCard"
                        :loadingBtn="loadingBtn"
                        :error="error"
                        :errorMessage="errorMessage"
                    ></card-form>
                </div>
            </div>
            <div class="select-payment-content-pane" :class="{ 'active show': isActive('bank_slip') }" id="bank_slip">
                <div class="atention-split">
                    <div><span>!</span></div>
                    <p>
                        Ao optar pelo boleto, seu pagamento será reconhecido em até <strong>3 dias úteis.</strong>
                    </p>
                </div>
                <div class="payment-radios" v-for="bankSlip in bankSlips" :key="bankSlip">
                    <div @click="$emit('setSelectedCard', '')">
                        <input
                            class="with-gap"
                            v-model="selectedBankSlip"
                            :value="bankSlip"
                            id="bankSlip"
                            type="radio"
                        />
                        <label class="payment-radios-label" for="bankSlip">
                            <p>Pagamento com Boleto à vista.</p>
                        </label>
                    </div>
                </div>
            </div>
            <div class="select-payment-content-pane" :class="{ 'active show': isActive('pix') }" id="pix">
                <div v-if="!showQrCode">
                    <div class="payment-radios" v-for="pix in pixList" :key="pix">
                        <div @click="$emit('setSelectedCard', '')">
                            <input class="with-gap" v-model="selectedPix" :value="pix" id="pix-payment" type="radio" />
                            <label class="payment-radios-label" for="pix-payment">
                                <p>Pagamento com Pix à vista</p>
                            </label>
                        </div>
                    </div>
                </div>
                <div v-else class="pix-payment-qrcode">
                    <div v-if="!qrCodePath.length">
                        <div class="card-checkout-loading">
                            <eg-loading :size="50" />
                        </div>
                        Gerando QR Code...
                    </div>
                    <div v-else>
                        <span>Aponte a câmera para o QR Code!</span>
                        <object :data="qrCodePath" type="image/svg+xml"></object>
                        <span>Validando transação em {{ counter }} segundos.</span>
                        <div class="qrcode-button">
                            <eg-button
                                variant="eg-blue-outline"
                                type="button"
                                block
                                class="button-send"
                                @click="copyCode"
                            >
                                Copiar Código do QR Code
                            </eg-button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import CardForm from '@/components/new-checkout/creditcard/card-form';
import CardList from '@/components/new-checkout/creditcard/card-list';
import { createCreditCard, deleteCreditCard } from '@/services/api/transactions.js';
import { mapActions } from 'vuex';
export default {
    components: { CardForm, CardList },
    name: 'SelectPayment',
    data: () => ({
        activeItem: 'credit_card',
        loadingBtn: false,
        error: false,
        errorMessage: [],
        selectedBankSlip: '',
        bankSlips: ['boleto'],
        selectedPix: '',
        pixList: ['pix']
    }),
    props: {
        disabled: {
            type: Boolean,
            default: false
        },
        creditCards: {
            type: Array
        },
        showForm: {
            type: Boolean
        },
        changeSelectedCard: {
            type: Boolean,
            default: true
        },
        qrCodePath: {
            type: String,
            default: ''
        },
        showQrCode: {
            type: Boolean,
            default: false
        },
        counter: {
            type: Number
        },
        qrCodeLink: {
            type: String
        }
    },
    methods: {
        ...mapActions('sweetalert2', ['showAlert']),
        ...mapActions('notification', ['showNotification']),
        isActive(menuItem) {
            return this.activeItem === menuItem;
        },
        setActive(item) {
            this.activeItem = item;
            this.$emit('paymentMethodCode', item);
        },
        async registerCard(form) {
            try {
                this.loadingBtn = true;
                await createCreditCard(form);
                const result = await this.$swal({
                    title: 'Seu cartão foi cadastrado!',
                    icon: 'success',
                    allowOutsideClick: false
                });
                if (result && result.isConfirmed) {
                    this.$emit('getCreditCardList');
                }
            } catch (error) {
                this.loadingBtn = false;
                console.error(error);
                this.showNotification({ text: 'Erro ao cadastrar cartão de crédito!', type: 'error' });
                this.errorMessage = error.response.data.errors;
                this.error = !this.error;
            } finally {
                this.loadingBtn = false;
            }
        },
        async deleteSelectedCard(id) {
            try {
                this.loadingBtn = true;
                await deleteCreditCard(id);
                const result = await this.$swal({
                    title: 'Seu cartão foi removido!',
                    icon: 'success',
                    allowOutsideClick: false
                });
                if (result && result.isConfirmed) {
                    this.$emit('getCreditCardList');
                }
            } catch (error) {
                this.loadingBtn = false;
                console.error(error);
                this.showNotification({ text: 'Erro ao excluir cartão de crédito!', type: 'error' });
                this.errorMessage = error.response.data.errors;
                this.error = !this.error;
            } finally {
                this.loadingBtn = false;
            }
        },
        openForm() {
            this.$emit('openForm');
        },
        setSelectedCard(card) {
            this.$emit('setSelectedCard', card);
        },
        copyCode() {
            const code = this.qrCodeLink;
            navigator.clipboard.writeText(code).then(() => {
                this.showNotification({ text: 'Código do QR Code copiado com sucesso!', type: 'success' });
            });
        }
    },
    computed: {
        getCreditCardList() {
            return this.creditCards.length > 0 ? true : false;
        }
    },
    watch: {
        changeSelectedCard: {
            deep: true,
            handler() {
                this.selectedBankSlip = '';
                this.selectedPix = '';
            }
        }
    }
};
</script>

<style scoped>
.select-payment-tabs {
    display: grid;
    grid-template-columns: repeat(3, 1fr);
    gap: 20px;
    justify-content: space-around;
    margin-bottom: 20px;
    box-sizing: border-box;
    width: 100%;
}
.select-payment-tab {
    text-align: center;
}
.select-payment-tab-link {
    padding: 10px 3px;
    border: 1px solid #707070;
    border-radius: 4px;
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    font-weight: 600;
    font-size: 16px;
    line-height: 19px;
    color: #707070;
    gap: 4px;
    box-sizing: border-box;
}
.select-payment-tab-link:hover {
    background-color: rgba(112, 112, 112, 0.1);
}
.select-payment-tab-link.active {
    color: #fff;
    background: #007bff;
    border: 1px solid #007bff;
    border-radius: 4px;
}
.select-payment-tab-link.disabled {
    background: #dbdbdb;
    border: 1px solid #dbdbdb;
    color: #707070;
    cursor: default;
}
.select-payment-content-pane {
    display: none;
}
.show {
    display: block;
}
.payment-radios {
    padding: 20px;
    border: 1px solid #dbdbdb;
    border-radius: 3px;
    margin-bottom: 12px;
    display: flex;
    justify-content: space-between;
    align-items: center;
}
.payment-radios-label {
    display: flex !important;
    align-items: center;
    justify-content: flex-start;
    gap: 24px;
    font-weight: 600;
    color: #707070;
    width: 100%;
}
.pix-payment-qrcode {
    display: flex;
    flex-direction: column;
    align-items: center;
    padding: 24px;
    text-align: center;
}
.pix-payment-qrcode div {
    display: flex;
    flex-direction: column;
    align-items: center;
}
.card-checkout-loading {
    margin-bottom: 12px;
}
.pix-payment-qrcode object {
    height: 350px;
    max-width: 100%;
}
.qrcode-button {
    margin-top: 16px;
}
.creditcard-message {
    color: red;
}
.atention-split {
    padding: 12px;
    border-radius: 4px;
    background-color: #ffe8a8;
    display: flex;
    justify-content: center;
    align-items: center;
    gap: 16px;
    color: #000;
    margin-bottom: 20px;
    box-shadow: 0px 3px 6px rgba(0, 0, 0, 0.16);
}
.atention-split div span {
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 22px;
    background-color: #fdc30c;
    color: #ffe8a8;
    width: 30px;
    height: 30px;
    border-radius: 50%;
    box-sizing: border-box;
}
@media screen and (max-width: 1023px) {
    .select-payment-tabs {
        gap: 10px;
        margin-bottom: 10px;
    }
    .select-payment-tab-link {
        padding: 8px 12px;
    }
}
@media screen and (max-width: 442px) {
    .select-payment-tabs {
        grid-template-columns: repeat(1, 1fr);
    }
}
</style>
